<template>
    <div class="package-list">
        <h2 class="package-list__header" v-html="$t('Info.packages')"></h2>
        <ul v-if="packages.length > 0" class="package-list__items">
            <li v-for="(singlePackage, index) in packages" :key="index" class="package-list__item">
                <span class="icon-gift"></span>
                <span>{{ singlePackage.name }}</span>
            </li>
        </ul>
        <p v-else class="package-list__empty" v-html="$t('Info.no_packages_available')"></p>
    </div>
</template>

<script>
export default {
    props: {
        packages: {
            type: Array,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.package-list {
    display: flex;
    flex-direction: column;
    max-width: 382px;
    width: 100%;
    border-radius: 12px;

    &__header {
        font-size: 1.8rem;
        font-family: PlusJakartaSans-Medium, sans-serif;
        margin: 0 0 20px 0;

        [class*="desktop"] & {
            font-size: 2rem;
        }
    }

    &__items {
        list-style: none;
        padding: 0;
        margin: 0;
    }

    &__item {
        background: white;
        margin-bottom: 20px;
        border-radius: 8px;
        font-size: 1.4rem;
        color: $tuatara;

        .icon-gift {
            margin-right: 8px;
            font-size: 2rem;
            color: $lavender;
        }
    }

    &__empty {
        font-size: 1.4rem;
        color: $black;
        text-align: center;
    }
}
</style>
